module.exports = __webpack_public_path__ + "static/media/3.7e2a7b9a.jpg";